import React, { createContext, useContext, useEffect, useState } from 'react';

export const NavbarContext = createContext({
  productoActivo: null,
});

const NavbarProvider = ({ children }) => {
  const [productoActivo, setProductoActivo] = useState(null);
  const [tabActiva, setTabActiva] = useState(null);

  return (
    <NavbarContext.Provider
      value={{
        productoActivo,
        setProductoActivo,
        tabActiva,
        setTabActiva,
      }}
    >
      {children}
    </NavbarContext.Provider>
  );
};

export default NavbarProvider;

export const useNavbarContext = (producto = '') => {
  const { productoActivo, setProductoActivo, tabActiva, setTabActiva } =
    useContext(NavbarContext);
  useEffect(() => {
    setProductoActivo(producto);
  }, [producto, setProductoActivo]);

  return { productoActivo, setProductoActivo, tabActiva, setTabActiva };
};
